module.exports = __webpack_public_path__ + "8af515cf552bb1d1c4d3388375b0d894.svg";